module.exports = __webpack_public_path__ + "static/media/Tagsmanager.4c1210c8.svg";